!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("@driftt/tide-core"), require("react-dom"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "react-dom"], t);else {
    var n = "object" === typeof exports ? t(require("react"), require("@driftt/tide-core"), require("react-dom")) : t(e.react, e["@driftt/tide-core"], e["react-dom"]);
    for (var a in n) ("object" === typeof exports ? exports : e)[a] = n[a];
  }
}(window, function (e, t, n) {
  return function (e) {
    var t = {};
    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var a = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, __webpack_require__), a.l = !0, a.exports;
    }
    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) __webpack_require__.d(n, a, function (t) {
        return e[t];
      }.bind(null, a));
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 8);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    var a = n(9);
    "string" === typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    n(6)(a, o);
    a.locals && (e.exports = a.locals);
  }, function (e, t, n) {
    var a;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;
      function classNames() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var a = arguments[t];
          if (a) {
            var o = typeof a;
            if ("string" === o || "number" === o) e.push(a);else if (Array.isArray(a) && a.length) {
              var i = classNames.apply(null, a);
              i && e.push(i);
            } else if ("object" === o) for (var r in a) n.call(a, r) && a[r] && e.push(r);
          }
        }
        return e.join(" ");
      }
      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (a = function () {
        return classNames;
      }.apply(t, [])) || (e.exports = a);
    }();
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    var a = n(10);
    "string" === typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    n(6)(a, o);
    a.locals && (e.exports = a.locals);
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var n = function cssWithMappingToString(e, t) {
            var n = e[1] || "",
              a = e[3];
            if (!a) return n;
            if (t && "function" === typeof btoa) {
              var o = function toComment(e) {
                  return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
                }(a),
                i = a.sources.map(function (e) {
                  return "/*# sourceURL=" + a.sourceRoot + e + " */";
                });
              return [n].concat(i).concat([o]).join("\n");
            }
            return [n].join("\n");
          }(t, e);
          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" === typeof e && (e = [[null, e, ""]]);
        for (var a = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];
          null != i && (a[i] = !0);
        }
        for (o = 0; o < e.length; o++) {
          var r = e[o];
          null != r[0] && a[r[0]] || (n && !r[2] ? r[2] = n : n && (r[2] = "(" + r[2] + ") and (" + n + ")"), t.push(r));
        }
      }, t;
    };
  }, function (e, t, n) {
    "use strict";

    var a = {},
      o = function isOldIE() {
        var e;
        return function memorize() {
          return "undefined" === typeof e && (e = Boolean(window && document && document.all && !window.atob)), e;
        };
      }(),
      i = function getTarget() {
        var e = {};
        return function memorize(t) {
          if ("undefined" === typeof e[t]) {
            var n = document.querySelector(t);
            if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
              n = n.contentDocument.head;
            } catch (a) {
              n = null;
            }
            e[t] = n;
          }
          return e[t];
        };
      }();
    function listToStyles(e, t) {
      for (var n = [], a = {}, o = 0; o < e.length; o++) {
        var i = e[o],
          r = t.base ? i[0] + t.base : i[0],
          l = {
            css: i[1],
            media: i[2],
            sourceMap: i[3]
          };
        a[r] ? a[r].parts.push(l) : n.push(a[r] = {
          id: r,
          parts: [l]
        });
      }
      return n;
    }
    function addStylesToDom(e, t) {
      for (var n = 0; n < e.length; n++) {
        var o = e[n],
          i = a[o.id],
          r = 0;
        if (i) {
          for (i.refs++; r < i.parts.length; r++) i.parts[r](o.parts[r]);
          for (; r < o.parts.length; r++) i.parts.push(addStyle(o.parts[r], t));
        } else {
          for (var l = []; r < o.parts.length; r++) l.push(addStyle(o.parts[r], t));
          a[o.id] = {
            id: o.id,
            refs: 1,
            parts: l
          };
        }
      }
    }
    function insertStyleElement(e) {
      var t = document.createElement("style");
      if ("undefined" === typeof e.attributes.nonce) {
        var a = n.nc;
        a && (e.attributes.nonce = a);
      }
      if (Object.keys(e.attributes).forEach(function (n) {
        t.setAttribute(n, e.attributes[n]);
      }), "function" === typeof e.insert) e.insert(t);else {
        var o = i(e.insert || "head");
        if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        o.appendChild(t);
      }
      return t;
    }
    var r = function replaceText() {
      var e = [];
      return function replace(t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();
    function applyToSingletonTag(e, t, n, a) {
      var o = n ? "" : a.css;
      if (e.styleSheet) e.styleSheet.cssText = r(t, o);else {
        var i = document.createTextNode(o),
          l = e.childNodes;
        l[t] && e.removeChild(l[t]), l.length ? e.insertBefore(i, l[t]) : e.appendChild(i);
      }
    }
    var l = null,
      d = 0;
    function addStyle(e, t) {
      var n, a, o;
      if (t.singleton) {
        var i = d++;
        n = l || (l = insertStyleElement(t)), a = applyToSingletonTag.bind(null, n, i, !1), o = applyToSingletonTag.bind(null, n, i, !0);
      } else n = insertStyleElement(t), a = function applyToTag(e, t, n) {
        var a = n.css,
          o = n.media,
          i = n.sourceMap;
        if (o && e.setAttribute("media", o), i && btoa && (a += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), e.styleSheet) e.styleSheet.cssText = a;else {
          for (; e.firstChild;) e.removeChild(e.firstChild);
          e.appendChild(document.createTextNode(a));
        }
      }.bind(null, n, t), o = function remove() {
        !function removeStyleElement(e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(n);
      };
      return a(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          a(e = t);
        } else o();
      };
    }
    e.exports = function (e, t) {
      (t = t || {}).attributes = "object" === typeof t.attributes ? t.attributes : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = o());
      var n = listToStyles(e, t);
      return addStylesToDom(n, t), function update(e) {
        for (var o = [], i = 0; i < n.length; i++) {
          var r = n[i],
            l = a[r.id];
          l && (l.refs--, o.push(l));
        }
        e && addStylesToDom(listToStyles(e, t), t);
        for (var d = 0; d < o.length; d++) {
          var s = o[d];
          if (0 === s.refs) {
            for (var A = 0; A < s.parts.length; A++) s.parts[A]();
            delete a[s.id];
          }
        }
      };
    };
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, n) {
    e.exports = n(11);
  }, function (e, t, n) {
    (t = e.exports = n(5)(!0)).push([e.i, "/* containers */\n\n.styles_tideModalContainer__35Q-U {\n  --tide-modal-border-radius: 3px;\n  --tide-modal-close-button-channel: 30px;\n  --tide-modal-element-spacing: 24px;\n  --drift-widget-zindex: 2147483647;\n  align-items: center;\n  -webkit-animation-duration: .5s;\n          animation-duration: .5s;\n  -webkit-animation-name: styles_modalFadeIn__fSHUf;\n          animation-name: styles_modalFadeIn__fSHUf;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: calc(var(--drift-widget-zindex) - 1);\n}\n\n.styles_tideModalContainer__35Q-U.styles_fullscreen__BcXai {\n  z-index: var(--drift-widget-zindex);\n}\n\n.styles_tideModalOverlay__1lWBC {\n  background: rgba(var(--color-p1-a), 0.6);\n  height: 100vh;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n}\n\n.styles_tideModal__8Pxoy {\n  width: var(--tide-modal-width);\n  background: var(--main-white);\n  border-radius: var(--tide-modal-border-radius);\n  box-shadow: var(--box-shadow-2);\n  position: relative;\n}\n\n.styles_tideModal__8Pxoy.styles_small__20xfX {\n  --tide-modal-width: 450px;\n}\n\n.styles_tideModal__8Pxoy.styles_medium__fFoRq {\n  --tide-modal-width: 578px;\n}\n\n.styles_tideModal__8Pxoy.styles_large__VYhYm {\n  --tide-modal-width: 720px;\n}\n\n.styles_tideModal__8Pxoy.styles_xlarge__3f_41 {\n  --tide-modal-width: 955px;\n}\n\n.styles_tideModal__8Pxoy.styles_fullscreen__BcXai {\n  --tide-modal-width: 100vw;\n  --tide-modal-border-radius: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n\n.styles_tideModalCloseButton__2IRxa {\n  display: block;\n  position: absolute;\n  right: 8px;\n  top: 15px;\n}\n\n/* title */\n\n.styles_tideModalTitle__w1rdX {\n  margin: var(--tide-modal-element-spacing) var(--tide-modal-close-button-channel) 8px var(--tide-modal-element-spacing);\n}\n\n.styles_tideModalBody__vWYUw > .styles_tideModalTitle__w1rdX,\n.styles_tideModalSidebar__3D8Gm > .styles_tideModalTitle__w1rdX {\n  margin-left: 0;\n}\n\n.styles_tideModalSplitView__3gtb2 > .styles_tideModalBody__vWYUw > .styles_tideModalTitle__w1rdX,\n.styles_tideModalSplitView__3gtb2 > .styles_tideModalSidebar__3D8Gm > .styles_tideModalTitle__w1rdX {\n  margin-top: 0;\n}\n\n/* splitView */\n\n.styles_tideModalSplitView__3gtb2 {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-rows: auto 1fr;\n  overflow-y: auto;\n  max-height: 70vh;\n}\n\n.styles_fullscreen__BcXai .styles_tideModalSplitView__3gtb2 {\n  max-height: unset;\n}\n\n/* body */\n\n.styles_tideModalBody__vWYUw {\n  margin-top: var(--tide-modal-element-spacing);\n  max-height: 60vh;\n  overflow-y: auto;\n  padding: 0 var(--tide-modal-close-button-channel) var(--tide-modal-element-spacing) var(--tide-modal-element-spacing);\n}\n\n.styles_fullscreen__BcXai .styles_tideModalBody__vWYUw {\n  flex-grow: 1;\n  max-height: unset;\n}\n\n.styles_tideModalTitle__w1rdX + .styles_tideModalBody__vWYUw {\n  margin-top: 0;\n}\n\n.styles_tideModalSplitView__3gtb2 > .styles_tideModalBody__vWYUw {\n  grid-row: 2;\n  margin-top: var(--tide-modal-element-spacing);\n  max-height: unset;\n}\n\n.styles_tideModalSplitView__3gtb2 > .styles_tideModalTitle__w1rdX + .styles_tideModalBody__vWYUw {\n  margin-top: 0;\n}\n\n/* sidebar */\n\n.styles_tideModalSidebar__3D8Gm {\n  background: var(--color-p1-4);\n  border-top-right-radius: var(--tide-modal-border-radius);\n  grid-row: span 2;\n  overflow-y: auto;\n  padding: var(--tide-modal-element-spacing) var(--tide-modal-close-button-channel) var(--tide-modal-element-spacing) var(--tide-modal-element-spacing);\n}\n\n.styles_tideModalSidebar__3D8Gm.styles_small__20xfX {\n  width: calc(var(--tide-modal-width) * 0.33);\n}\n\n.styles_tideModalSidebar__3D8Gm.styles_large__VYhYm {\n  width: calc(var(--tide-modal-width) * 0.66);\n}\n\n/* footer */\n\n.styles_tideModalFooter__1aBoW {\n  border-top: 1px solid var(--color-p1-4);\n  padding: var(--tide-modal-element-spacing) var(--tide-modal-close-button-channel) var(--tide-modal-element-spacing) var(--tide-modal-element-spacing);\n}\n\n@-webkit-keyframes styles_modalFadeIn__fSHUf {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes styles_modalFadeIn__fSHUf {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n", "", {
      version: 3,
      sources: ["styles.module.css"],
      names: [],
      mappings: "AAAA,eAAe;;AAEf;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,kCAAkC;EAClC,iCAAiC;EACjC,mBAAmB;EACnB,+BAAuB;UAAvB,uBAAuB;EACvB,iDAA2B;UAA3B,yCAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,eAAe;EACf,MAAM;EACN,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,OAAO;EACP,eAAe;EACf,MAAM;EACN,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,8CAA8C;EAC9C,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA,UAAU;;AAEV;EACE,sHAAsH;AACxH;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA,cAAc;;AAEd;EACE,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,SAAS;;AAET;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;EAChB,qHAAqH;AACvH;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,YAAY;;AAEZ;EACE,6BAA6B;EAC7B,wDAAwD;EACxD,gBAAgB;EAChB,gBAAgB;EAChB,qJAAqJ;AACvJ;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,WAAW;;AAEX;EACE,uCAAuC;EACvC,qJAAqJ;AACvJ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAPA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF",
      file: "styles.module.css",
      sourcesContent: ["/* containers */\n\n.tideModalContainer {\n  --tide-modal-border-radius: 3px;\n  --tide-modal-close-button-channel: 30px;\n  --tide-modal-element-spacing: 24px;\n  --drift-widget-zindex: 2147483647;\n  align-items: center;\n  animation-duration: .5s;\n  animation-name: modalFadeIn;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: calc(var(--drift-widget-zindex) - 1);\n}\n\n.tideModalContainer.fullscreen {\n  z-index: var(--drift-widget-zindex);\n}\n\n.tideModalOverlay {\n  background: rgba(var(--color-p1-a), 0.6);\n  height: 100vh;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n}\n\n.tideModal {\n  width: var(--tide-modal-width);\n  background: var(--main-white);\n  border-radius: var(--tide-modal-border-radius);\n  box-shadow: var(--box-shadow-2);\n  position: relative;\n}\n\n.tideModal.small {\n  --tide-modal-width: 450px;\n}\n\n.tideModal.medium {\n  --tide-modal-width: 578px;\n}\n\n.tideModal.large {\n  --tide-modal-width: 720px;\n}\n\n.tideModal.xlarge {\n  --tide-modal-width: 955px;\n}\n\n.tideModal.fullscreen {\n  --tide-modal-width: 100vw;\n  --tide-modal-border-radius: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n\n.tideModalCloseButton {\n  display: block;\n  position: absolute;\n  right: 8px;\n  top: 15px;\n}\n\n/* title */\n\n.tideModalTitle {\n  margin: var(--tide-modal-element-spacing) var(--tide-modal-close-button-channel) 8px var(--tide-modal-element-spacing);\n}\n\n.tideModalBody > .tideModalTitle,\n.tideModalSidebar > .tideModalTitle {\n  margin-left: 0;\n}\n\n.tideModalSplitView > .tideModalBody > .tideModalTitle,\n.tideModalSplitView > .tideModalSidebar > .tideModalTitle {\n  margin-top: 0;\n}\n\n/* splitView */\n\n.tideModalSplitView {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-rows: auto 1fr;\n  overflow-y: auto;\n  max-height: 70vh;\n}\n\n.fullscreen .tideModalSplitView {\n  max-height: unset;\n}\n\n/* body */\n\n.tideModalBody {\n  margin-top: var(--tide-modal-element-spacing);\n  max-height: 60vh;\n  overflow-y: auto;\n  padding: 0 var(--tide-modal-close-button-channel) var(--tide-modal-element-spacing) var(--tide-modal-element-spacing);\n}\n\n.fullscreen .tideModalBody {\n  flex-grow: 1;\n  max-height: unset;\n}\n\n.tideModalTitle + .tideModalBody {\n  margin-top: 0;\n}\n\n.tideModalSplitView > .tideModalBody {\n  grid-row: 2;\n  margin-top: var(--tide-modal-element-spacing);\n  max-height: unset;\n}\n\n.tideModalSplitView > .tideModalTitle + .tideModalBody {\n  margin-top: 0;\n}\n\n/* sidebar */\n\n.tideModalSidebar {\n  background: var(--color-p1-4);\n  border-top-right-radius: var(--tide-modal-border-radius);\n  grid-row: span 2;\n  overflow-y: auto;\n  padding: var(--tide-modal-element-spacing) var(--tide-modal-close-button-channel) var(--tide-modal-element-spacing) var(--tide-modal-element-spacing);\n}\n\n.tideModalSidebar.small {\n  width: calc(var(--tide-modal-width) * 0.33);\n}\n\n.tideModalSidebar.large {\n  width: calc(var(--tide-modal-width) * 0.66);\n}\n\n/* footer */\n\n.tideModalFooter {\n  border-top: 1px solid var(--color-p1-4);\n  padding: var(--tide-modal-element-spacing) var(--tide-modal-close-button-channel) var(--tide-modal-element-spacing) var(--tide-modal-element-spacing);\n}\n\n@keyframes modalFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"]
    }]), t.locals = {
      tideModalContainer: "styles_tideModalContainer__35Q-U",
      modalFadeIn: "styles_modalFadeIn__fSHUf",
      fullscreen: "styles_fullscreen__BcXai",
      tideModalOverlay: "styles_tideModalOverlay__1lWBC",
      tideModal: "styles_tideModal__8Pxoy",
      small: "styles_small__20xfX",
      medium: "styles_medium__fFoRq",
      large: "styles_large__VYhYm",
      xlarge: "styles_xlarge__3f_41",
      tideModalCloseButton: "styles_tideModalCloseButton__2IRxa",
      tideModalTitle: "styles_tideModalTitle__w1rdX",
      tideModalBody: "styles_tideModalBody__vWYUw",
      tideModalSidebar: "styles_tideModalSidebar__3D8Gm",
      tideModalSplitView: "styles_tideModalSplitView__3gtb2",
      tideModalFooter: "styles_tideModalFooter__1aBoW"
    };
  }, function (e, t, n) {
    (t = e.exports = n(5)(!0)).push([e.i, ".styles_tideModalStatusBar__3ZBge {\n  border-radius: var(--tide-modal-border-radius) var(--tide-modal-border-radius) 0 0;\n  height: 8px;\n}\n\n.styles_tideModalStatusBar__3ZBge.styles_none__2E8gG {\n  display: none;\n}\n\n.styles_tideModalStatusBar__3ZBge.styles_default__3BM5R {\n  background: var(--color-p1-10);\n}\n\n.styles_tideModalStatusBar__3ZBge.styles_warning__23sHH {\n  background: var(--color-s2-6);\n}\n\n.styles_tideModalStatusBar__3ZBge.styles_error__1xUJn {\n  background: var(--color-s3-6);\n}\n\n.styles_tideModalStatusBar__3ZBge.styles_marketable-moment__gvfQx {\n  background: linear-gradient(116.54deg, #ED1886 -0.39%, #8711FF 103.35%);\n}\n", "", {
      version: 3,
      sources: ["styles.module.css"],
      names: [],
      mappings: "AAAA;EACE,kFAAkF;EAClF,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uEAAuE;AACzE",
      file: "styles.module.css",
      sourcesContent: [".tideModalStatusBar {\n  border-radius: var(--tide-modal-border-radius) var(--tide-modal-border-radius) 0 0;\n  height: 8px;\n}\n\n.tideModalStatusBar.none {\n  display: none;\n}\n\n.tideModalStatusBar.default {\n  background: var(--color-p1-10);\n}\n\n.tideModalStatusBar.warning {\n  background: var(--color-s2-6);\n}\n\n.tideModalStatusBar.error {\n  background: var(--color-s3-6);\n}\n\n.tideModalStatusBar.marketable-moment {\n  background: linear-gradient(116.54deg, #ED1886 -0.39%, #8711FF 103.35%);\n}\n"]
    }]), t.locals = {
      tideModalStatusBar: "styles_tideModalStatusBar__3ZBge",
      none: "styles_none__2E8gG",
      default: "styles_default__3BM5R",
      warning: "styles_warning__23sHH",
      error: "styles_error__1xUJn",
      "marketable-moment": "styles_marketable-moment__gvfQx"
    };
  }, function (e, t, n) {
    "use strict";

    function _objectWithoutProperties(e, t) {
      if (null == e) return {};
      var n,
        a,
        o = function _objectWithoutPropertiesLoose(e, t) {
          if (null == e) return {};
          var n,
            a,
            o = {},
            i = Object.keys(e);
          for (a = 0; a < i.length; a++) n = i[a], t.indexOf(n) >= 0 || (o[n] = e[n]);
          return o;
        }(e, t);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for (a = 0; a < i.length; a++) n = i[a], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
      return o;
    }
    n.r(t);
    var a = n(0),
      o = n.n(a),
      i = n(2),
      r = n.n(i),
      l = n(3),
      d = n(1),
      s = n.n(d);
    const A = e => {
      let t = e.className,
        n = _objectWithoutProperties(e, ["className"]);
      return o.a.createElement(l.H2, Object.assign({
        className: r()(s.a.tideModalTitle, t)
      }, n));
    };
    A.displayName = "ModalTitle";
    var c = A;
    const u = o.a.forwardRef((e, t) => {
      let n = e.className,
        a = _objectWithoutProperties(e, ["className"]);
      return o.a.createElement("div", Object.assign({
        ref: t,
        className: r()(s.a.tideModalSplitView, n)
      }, a));
    });
    u.displayName = "ModalSplitView";
    var _ = u;
    const m = o.a.forwardRef((e, t) => {
      let n = e.className,
        a = _objectWithoutProperties(e, ["className"]);
      return o.a.createElement("div", Object.assign({
        ref: t,
        className: r()(s.a.tideModalBody, n)
      }, a));
    });
    m.displayName = "ModalBody";
    var p = m;
    const f = o.a.forwardRef((e, t) => {
      let n = e.className,
        a = e.size,
        i = void 0 === a ? "small" : a,
        l = _objectWithoutProperties(e, ["className", "size"]);
      return o.a.createElement("div", Object.assign({
        ref: t,
        className: r()(s.a.tideModalSidebar, s.a[i], n)
      }, l));
    });
    f.displayName = "ModalSidebar";
    var y = f;
    const g = o.a.forwardRef((e, t) => {
      let n = e.className,
        a = _objectWithoutProperties(e, ["className"]);
      return o.a.createElement("div", Object.assign({
        ref: t,
        className: r()(s.a.tideModalFooter, n)
      }, a));
    });
    g.displayName = "ModalFooter";
    var v = g,
      C = n(7),
      E = n.n(C),
      b = n(4),
      h = n.n(b);
    var B = _ref => {
      let {
        status: e
      } = _ref;
      return o.a.createElement("div", {
        className: r()(h.a.tideModalStatusBar, h.a[e])
      });
    };
    var M = o.a.createContext(null);
    const w = o.a.forwardRef((e, t) => {
      let n = e.open,
        a = e.status,
        i = void 0 === a ? "default" : a,
        d = e.size,
        A = void 0 === d ? "medium" : d,
        c = e.onClose,
        u = e.hideCloseButton,
        _ = e.className,
        m = e.children,
        p = _objectWithoutProperties(e, ["open", "status", "size", "onClose", "hideCloseButton", "className", "children"]);
      const f = c,
        y = r()(s.a.tideModalContainer, s.a[A]),
        g = r()(s.a.tideModal, s.a[A], _);
      return n ? E.a.createPortal(o.a.createElement("div", {
        className: y
      }, o.a.createElement("div", {
        className: s.a.tideModalOverlay,
        onClick: f
      }), o.a.createElement("div", Object.assign({
        ref: t,
        className: g
      }, p), o.a.createElement(B, {
        status: i
      }), !u && o.a.createElement(l.IconButton, {
        size: "small",
        className: s.a.tideModalCloseButton,
        icon: "close",
        onClick: c
      }), o.a.createElement(M.Provider, {
        value: c
      }, m))), document.body) : null;
    });
    w.displayName = "Modal";
    var x = w;
    var S = () => {
      const e = o.a.useContext(M);
      if ("function" !== typeof e) throw new Error("The useCloseModal hook may only be used by descendants of a Modal component.");
      return e;
    };
    n.d(t, "ModalTitle", function () {
      return c;
    }), n.d(t, "ModalSplitView", function () {
      return _;
    }), n.d(t, "ModalBody", function () {
      return p;
    }), n.d(t, "ModalSidebar", function () {
      return y;
    }), n.d(t, "ModalFooter", function () {
      return v;
    }), n.d(t, "Modal", function () {
      return x;
    }), n.d(t, "useCloseModal", function () {
      return S;
    });
  }]);
});